import { ValidatorForm } from 'react-form-validator-core';
import React, { useEffect, useState, useRef } from 'react';

import { FormContext, FormValidatorContext } from './FormContext';

type FormValidatorProps = {
  id?: string;
  name?: string;
  onSubmit: () => void,
  validated?: boolean;
  ctx?: FormValidatorContext;
  className?: string;
  children: React.ReactNode;
  instantValidate?: boolean
}

const defaultContext = (validated: boolean): FormValidatorContext => ({
  wasValidated: validated
});

const FormValidator = (
  { onSubmit, validated = false, ctx, className, children, ...rest }: FormValidatorProps
): React.JSX.Element => {
  const [context, setContext] = useState(ctx || defaultContext(validated));
  const formRef = useRef();

  const handleError = (error) => {
    setContext({ error, wasValidated: true });
  };

  useEffect(() => {
    setContext(ctx || defaultContext(validated));
  }, [validated]);

  return (
    <FormContext.Provider value={context}>
      <ValidatorForm
        ref={formRef}
        className={`${className || ''}${context.wasValidated ? ' is-submitted' : ''}`}
        onSubmit={onSubmit}
        onError={handleError}
        instantValidate
        data-test-id="form-validator"
        {...rest}
      >
        {children}
      </ValidatorForm>
    </FormContext.Provider>
  );
};

export default FormValidator;
